// The five system variables an email template resolves automatically from the
// recipient contact. These are never collected by hand in the composer — the
// server render endpoint fills them. Keep in sync with the backend
// `emailTemplate.constants.js` (SYSTEM_VARIABLE_NAMES).

export const SYSTEM_VARIABLE_DEFS = [
  { name: 'firstName', label: 'First name' },
  { name: 'lastName', label: 'Last name' },
  { name: 'company', label: 'Company' },
  { name: 'title', label: 'Job title' },
  { name: 'email', label: 'Email' },
] as const;

// Location variables, filled from the recipient's site when a template is applied
// in the email composer. Sequences and the Prospecting default template can't use
// them. Keep in sync with the backend `emailTemplate.constants.js`
// (LOCATION_VARIABLE_NAMES).
export const LOCATION_VARIABLE_DEFS = [
  { name: 'city', label: 'City' },
  { name: 'state', label: 'State' },
  { name: 'address', label: 'Street address' },
  { name: 'zip', label: 'ZIP' },
] as const;

export const SYSTEM_VARIABLE_KEYS: ReadonlySet<string> = new Set(
  [...SYSTEM_VARIABLE_DEFS, ...LOCATION_VARIABLE_DEFS].map((v) => v.name)
);

export function isSystemVariable(key: string): boolean {
  return SYSTEM_VARIABLE_KEYS.has(key);
}
